import _ from "lodash";
import { path } from "../../api";
import * as actions from "../../utils/actions";
import { restClient } from "../../utils/restClient";

const initialState = {
  adminProfiles: [],
  adminProfile: null,
};

export default {
  namespaced: true,
  name: "adminProfiles",
  state: _.cloneDeep(initialState),
  mutations: {
    [actions.GET_ADMIN_PROFILE](state, payload = null) {
      state.adminProfile = payload;
    },
    [actions.GET_ADMIN_PROFILES](state, payload = []) {
      state.adminProfiles = payload;
    },
    [actions.CREATE_ADMIN_PROFILE](state, payload = null) {
      state.adminProfile = payload;
    },
    [actions.UPDATE_ADMIN_PROFILE](state, payload = null) {
      state.adminProfile = payload;
    },
    [actions.DELETE_ADMIN_PROFILE](state, payload = null) {
      state.adminProfile = payload;
    },
    [actions.RESET_ADMIN_PROFILE_FORM](state) {
      state.adminProfile = null;
    },
  },
  actions: {
    async fetchAdminProfiles({ commit }, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.adminProfiles.base,
            "GET",
            null,
            payload
          );
          const list = Array.isArray(response.data)
            ? response.data
            : Array.isArray(response.data?.data)
            ? response.data.data
            : [];
          commit(actions.GET_ADMIN_PROFILES, list);
          resolve(response);
        } catch (error) {
          commit(actions.GET_ADMIN_PROFILES, []);
          reject(error);
        }
      });
    },
    async fetchAdminProfile({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await restClient(
            path.admin.adminProfiles.single(payload),
            "GET"
          );
          commit(actions.GET_ADMIN_PROFILE, data);
          resolve(data);
        } catch (error) {
          commit(actions.GET_ADMIN_PROFILE);
          reject(error);
        }
      });
    },
    async createAdminProfile({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.adminProfiles.base,
            "POST",
            payload
          );
          commit(actions.CREATE_ADMIN_PROFILE, response?.data);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async updateAdminProfile({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.adminProfiles.single(payload.id),
            "PUT",
            payload
          );
          commit(actions.UPDATE_ADMIN_PROFILE, response?.data);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteAdminProfile({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.adminProfiles.single(payload),
            "DELETE"
          );
          commit(actions.DELETE_ADMIN_PROFILE, response?.data);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    resetForm({ commit }) {
      commit(actions.RESET_ADMIN_PROFILE_FORM);
    },
  },
};
